import { useState, useCallback, useEffect } from 'react';
import axios from 'axios';
import endpoints from '../define/endpoints';

export default function useGetFeaturedListings(
  array_params,
  secondary_params = null
) {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [listings, setListings] = useState([]);

  const fetchListings = useCallback(async () => {
    try {
      setIsLoading(true);
      const { data: firstData } = await axios.get(
        `${endpoints.core}/listings`,
        {
          params: {
            ...array_params,
            context: 'search',
            locale: window.freedomeConfig.locale,
          },
        }
      );

      let combinedData = firstData;
      if (firstData.length < array_params._limit && secondary_params) {
        const { data: secondData } = await axios.get(
          `${endpoints.core}/listings`,
          {
            params: {
              ...secondary_params,
              context: 'search',
              locale: window.freedomeConfig.locale,
              _limit: array_params._limit - firstData.length,
            },
          }
        );

        combinedData = [...firstData, ...secondData];
      }

      setListings(combinedData);
    } catch (error) {
      setError(new Error(error));
      // console.error(error);
    } finally {
      setIsLoading(false);
    }
  }, [
    array_params?._limit,
    array_params?.latitude,
    array_params?.longitude,
    array_params?.distance,
    array_params['published_at[gte]'],
    secondary_params?._limit,
    secondary_params?.latitude,
    secondary_params?.longitude,
    secondary_params?.distance,
  ]);

  useEffect(() => {
    fetchListings();
  }, [fetchListings]);

  return { listings, isLoading, error, refetch: fetchListings };
}
